/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DowngradeSubscriptionRequest interface.
 */
export function instanceOfDowngradeSubscriptionRequest(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function DowngradeSubscriptionRequestFromJSON(json) {
    return DowngradeSubscriptionRequestFromJSONTyped(json, false);
}
export function DowngradeSubscriptionRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
    };
}
export function DowngradeSubscriptionRequestToJSON(json) {
    return DowngradeSubscriptionRequestToJSONTyped(json, false);
}
export function DowngradeSubscriptionRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
    };
}
